// Register.js
import React, { useState } from 'react';
import {
    Box,
    Paper,
    Typography,
    TextField,
    Button,
    MenuItem,
    Divider,
    CircularProgress,
    Alert,
} from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AuthService from '../Auth/AuthService';

// const roleTypes = ['ADMIN', 'USER', 'SUPERADMIN'];
const loginTypes = ['SCHOOL', 'MATRIMONY', 'STUDENT', 'CHURCH', 'HR', 'LIBRARY', 'TRANSPORT'];

const LoginRegister = () => {

    const [param] = useSearchParams();
    const code = param.get("code");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        email: '',
        mobile: '',
        password: '',
        roleType: 'ADMIN',
        loginType: "SCHOOL",
        isActive: true,
        masterCode: code || null,
    });

    const handleChange = (e) => {
        setError('');
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        console.log('Register Data:', formData);
        try {
            const rest = AuthService.pathUrl("POST", "/auth/register")
            const tokendata = await AuthService.registerLogin(rest, formData);
            if (tokendata.status === 404) {
                setError(tokendata.message);
                setLoading(false);
                return;
            }
            setLoading(false);
            setError('');
            if (tokendata?.is_verfied === true)
                navigate("/")
            else if (tokendata?.is_verfied === false)
                navigate("/verify");
            else if (tokendata.accessToken !== undefined)
                navigate("/loginview");
            window.location.reload();

            setTimeout(() => {
                setLoading(false);
            }, 1000);
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    return (
        <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="90vh"
            bgcolor="#f4f6f8"
        >
            <Paper elevation={4} sx={{ p: 4, width: '100%', maxWidth: 400, borderRadius: 5, }}>
                <Typography variant="h5" align="center" fontWeight={600} gutterBottom>
                    Complete Your Registration
                </Typography>
                <Divider sx={{ mb: 4 }} />
                <form onSubmit={handleSubmit}>
                    <TextField
                        label="Email"
                        name="email"
                        fullWidth
                        margin="normal"
                        value={formData.email}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Mobile"
                        name="mobile"
                        fullWidth
                        margin="normal"
                        value={formData.mobile}
                        onChange={handleChange}
                    />
                    <TextField
                        label="Password"
                        name="password"
                        type="password"
                        fullWidth
                        margin="normal"
                        value={formData.password}
                        onChange={handleChange}
                    />
                    <TextField
                        select
                        label="Register Type"
                        name="loginType"
                        fullWidth
                        margin="normal"
                        value={formData.loginType}
                        onChange={handleChange}
                    >
                        {loginTypes.map((type) => (
                            <MenuItem key={type} value={type}>
                                {type}
                            </MenuItem>
                        ))}
                    </TextField>
                    {error && (
                        <Alert severity="error" sx={{ mb: 2 }}>
                            {error}
                        </Alert>
                    )}
                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        startIcon={loading && <CircularProgress size={20} />}
                        sx={{
                            mt: 3,
                            bgcolor: '#1b1914',
                            fontWeight: 'bold',
                            fontSize: '16px',
                            paddingY: 1,
                            borderRadius: 6,
                            '&:hover': {
                                backgroundColor: '#332a14ff',
                            },
                        }}
                    >
                        Register
                    </Button>
                </form>
                <Typography variant="body2" mt={3} align="center" >
                    Aready have an account? <a href="login" style={{ color: '#2575fc' }}>Login</a>
                </Typography>
            </Paper>
        </Box>
    );
};

export default LoginRegister;
